import { Snackbar } from "@material-ui/core";
// import Files from "react-files";
// import { Add as AddIcon } from "@material-ui/icons";
import React, { useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
// import { useDispatch } from "react-redux";
// import axios from "axios";
// import Blob from "blob";
// import FormData from "form-data";
// import {
//   addNewBrand,
//   setFamilyNotificationState,
//   updateFamilyData,
// } from "../reduxSaga/actions";
import ProductService from "../services/ProductService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";

// import {
//   getAllWarehousesManager,

//   addNewRealWarehouse,
// } from "../reduxSaga/actions";

// const useStyles = makeStyles((theme) => ({
//   fab: {
//     position: "fixed",
//     bottom: 20,
//     right: 20,
//   },
//   container: {
//     borderRadius: 10,
//     boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
//     width: 500,
//     height: 300,
//     backgroundColor: "white",
//     position: "absolute",
//     top: -30,
//     bottom: 0,
//     left: 0,
//     right: 0,
//     margin: "auto",
//     [theme.breakpoints.down("sm")]: {
//       width: "100vw",
//       height: "100vh",
//     },
//   },
//   form: {
//     padding: theme.spacing(2),
//   },
//   item: {
//     marginBottom: theme.spacing(3),
//     marginTop: theme.spacing(3),
//   },

//   cancelAndAddButtom: {
//     marginBottom: theme.spacing(3),
//     marginTop: theme.spacing(5),
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },

//   input: {
//     "&::placeholder": {
//       fontStyle: "italic",
//     },
//   },
// }));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const EditFamily = ({ setOnEditFamily, oldFamilyData }) => {
  // const dispatch = useDispatch();

  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [name, setName] = useState(oldFamilyData.name);
  const [desc, setDesc] = useState(oldFamilyData.description);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeName = (event) => {
    setName(event.target.value);
  };

  const onChangeDesc = (event) => {
    setDesc(event.target.value);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnEditFamily(false);
  };

  const onEditFamily = () => {
    if (name == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le champ du nom est vide ! ");
    } else {
      ProductService.updateFamily(
        getCurrentUserId(),
        oldFamilyData.idFamily,
        name,
        desc
      )
        .then((response) => {
          setOpenAlert(true);

          setOnEditFamily(false);
          setOpen(false);
          window.location.reload(false);
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        id="edit-family"
        style={{ display: "block", background: "#00000066" }}
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Modifier la famille</h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Libellé</label>
                    <input
                      defaultValue={name}
                      onChange={onChangeName}
                      type="text"
                      id="inputName"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="form-group col-sm-12">
                  <label htmlFor="inputDescription">Description</label>
                  <textarea
                    placeholder="Saisir..."
                    onChange={onChangeDesc}
                    id="inputDescription"
                    className="form-control"
                    rows={2}
                    defaultValue={desc}
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                onClick={onEditFamily}
                class="btn btn-light"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <Modal open={open}>
        <Container className={classes.container}>
          <form className={classes.form} autoComplete="off">
            <div className={classes.item}>
              <TextField
                required
                id="standard-basic"
                label=" Taper le nouveau nom  "
                defaultValue={name}
                variant="outlined"
                size="small"
                style={{ width: "100%" }}
                onChange={onChangeName}
                InputProps={{
                  classes: { input: classes.input },
                }}
              />
            </div>
            <div className={classes.item}>
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={4}
                InputProps={{
                  classes: { input: classes.input },
                }}
                defaultValue={desc}
                variant="outlined"
                label="Taper la nouvelle description"
                size="small"
                style={{ width: "100%" }}
                onChange={onChangeDesc}
              />
            </div>

            <div className={classes.cancelAndAddButtom}>
              <Button
                variant="outlined"
                color="primary"
                style={{ marginRight: 20 }}
                onClick={onEditFamily}
              >
                Valider
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={onCancelButtonHandler}
              >
                Cancel
              </Button>
            </div>
          </form>
        </Container>
      </Modal> */}
      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EditFamily;
